export default "__VITE_ASSET__zbZ$iTBH__"